var map = {
	"./bg.png": 335,
	"./dust_scratches.png": 336,
	"./exclusive_paper.png": 337,
	"./handmade_paper.png": 338,
	"./logo-pt.png": 339,
	"./logo.png": 340,
	"./og-default.png": 341,
	"./ricepaper.png": 342,
	"./textured_paper.png": 343,
	"./white_paper.png": 344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 334;